import { motion } from "framer-motion";
import { Info, X } from "lucide-react";
import { useSilver } from "@/context/SilverContext";

export default function WorkspaceHeader() {
  const { setHowOpen, areas } = useSilver();
  const close = () => {
    window.close();
    setTimeout(() => { if (!window.closed) window.location.assign("/"); }, 180);
  };
  return (
    <header className="fixed inset-x-0 top-0 z-40 px-3 pt-3 sm:px-6 sm:pt-4">
      <motion.nav initial={{ y: -24, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }} aria-label="Workspace"
        className="mx-auto flex max-w-7xl items-center gap-3 rounded-full border border-white/10 bg-[rgba(12,30,16,0.72)] py-2 pl-4 pr-2 shadow-[0_20px_50px_-20px_rgba(0,0,0,0.6)] backdrop-blur-2xl sm:pl-5" data-testid="workspace-header">
        <a href="/" className="flex shrink-0 items-center" data-testid="workspace-logo"><img src="/brand/nichecom-wordmark-dark.png" alt="NicheCom" className="h-[18px] w-auto sm:h-5" /></a>
        <span className="hidden h-5 w-px bg-white/15 sm:block" aria-hidden="true" />
        <span className="hidden rounded-full border border-[#96C11F]/40 px-2.5 py-[3px] font-ui text-[9.5px] font-semibold tracking-[0.14em] text-[#C6EE5A] sm:inline-flex">AUDIENCE WORKSPACE</span>
        {areas.length > 0 && (
          <span className="hidden truncate font-ui text-[12px] text-white/55 md:inline" data-testid="workspace-areas-label">
            {areas.length <= 4 ? areas.join(" · ") : `${areas.slice(0, 3).join(" · ")} + ${areas.length - 3} more`}
          </span>
        )}
        <div className="ml-auto flex items-center gap-1">
          <button type="button" onClick={() => setHowOpen(true)} className="hidden items-center gap-1.5 rounded-full px-3.5 py-2 text-[13px] text-white/70 transition-colors hover:bg-white/5 hover:text-white sm:inline-flex" data-testid="workspace-how-calculated-btn">
            <Info className="h-3.5 w-3.5" /> How it's calculated
          </button>
          <button type="button" onClick={close} className="btn-ghost !px-4 !py-2.5 text-[13px]" data-testid="workspace-close-btn">
            <X className="h-4 w-4" /> <span className="hidden sm:inline">Close workspace</span><span className="sm:hidden">Close</span>
          </button>
        </div>
      </motion.nav>
    </header>
  );
}
